import React from 'react';
import { NavLink } from 'react-router-dom';

const NavBar = () => {
  return (
    <nav className="navbar">
      <NavLink to="/" end>Home</NavLink>
      {/* <NavLink to="/portfolio">Projects</NavLink> */}
      <NavLink to="/posts">Posts</NavLink>
      {/* <NavLink to="/resume">Resume</NavLink> */}
    </nav>
  );
};

export default NavBar;
